module.exports = __webpack_public_path__ + "img/p__石化.1ea71626.png";